const PERMISSIONS = {}
const RESULTS = {}
const request = () => {}

export { PERMISSIONS, RESULTS, request }
